// Vendor
import {updateAccessStatus, updateSending, updateInitApp, resetState} from '@helpers';
import $ from 'jquery';

export class CustomRefresh {
    constructor(body, url, props) {
        this.base_url = process.env.REACT_APP_URL_BACK;
        this.url = url;
        this.body = body;
        this.props = props;
    }

    async make_request_refresh() {
        const {access} = this.props.data;
        var result;
        try {
            result = await $.ajax({
                url: `${this.base_url}${this.url}`,
                type: 'POST',
                data: JSON.stringify(this.body),
                headers: {
                    "Content-Type": "application/json"
                }
            });
        } catch (error) {
            result = {response: error, status: error.status};
        }

        switch (result.status) {
            case 401:
            case 400:
                this.props.dispatch(updateInitApp(true));
                this.props.dispatch(updateSending(false));
                this.props.dispatch(resetState());
                throw `Session Expired`;
            default:
                var obj = result,
                    acc = access;
                acc.access = obj.access;
                var data = {...acc, isAccess: true};
                this.props.dispatch(updateAccessStatus(data));
                this.props.dispatch(updateSending(false));
                return obj;
        }
    }
}